import { GetRepayMaxValueParams, getRepayMaxValue } from '@/domain/action-max-value-getters/getRepayMaxValue'
import { MarketInfo } from '@/domain/market-info/marketInfo'
import { MarketWalletInfo } from '@/domain/wallet/useMarketWalletInfo'
import { RepayObjective } from '@/features/actions/flavours/repay/types'
import { DialogFormNormalizedData } from '../../common/logic/form'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'

export interface CreateRepayObjectivesParams {
  repaymentAsset: DialogFormNormalizedData
  initialToken: Token
  marketInfoIn1Epoch: MarketInfo
  marketInfoIn2Epochs: MarketInfo
  walletInfo: MarketWalletInfo
}

export function createRepayObjectives({
  repaymentAsset,
  initialToken,
  marketInfoIn1Epoch,
  marketInfoIn2Epochs,
  walletInfo,
}: CreateRepayObjectivesParams): RepayObjective[] {
  const repaySymbol = repaymentAsset.token.symbol

  const balance = walletInfo.findWalletBalanceForSymbol(repaySymbol)
  const chainConfigParams: Pick<GetRepayMaxValueParams, 'chain'> = {
    chain: {
      minRemainingNativeAsset: marketInfoIn1Epoch.nativeAssetInfo.minRemainingNativeAssetBalance,
    },
  }

  const repayMaxValueIn1Epoch = getRepayMaxValue({
    asset: {
      status: marketInfoIn1Epoch.findOnePositionBySymbol(repaySymbol).reserve.status,
      isNativeAsset: marketInfoIn1Epoch.nativeAssetInfo.nativeAssetSymbol === repaySymbol,
      debtToken: repaySymbol,
      collateralToken: undefined,
    },
    user: {
      balance,
      debt: marketInfoIn1Epoch.findOnePositionBySymbol(repaySymbol).borrowBalance,
      collateralAmount: NormalizedUnitNumber(0),
    },
    ...chainConfigParams,
    marketInfo: marketInfoIn1Epoch,
  })
  const repayMaxValueIn2Epochs = getRepayMaxValue({
    asset: {
      status: marketInfoIn2Epochs.findOnePositionBySymbol(repaySymbol).reserve.status,
      isNativeAsset: marketInfoIn2Epochs.nativeAssetInfo.nativeAssetSymbol === repaySymbol,
      debtToken: repaySymbol,
      collateralToken: undefined,
    },
    user: {
      balance,
      debt: marketInfoIn2Epochs.findOnePositionBySymbol(repaySymbol).borrowBalance,
      collateralAmount: NormalizedUnitNumber(0),
    },
    ...chainConfigParams,
    marketInfo: marketInfoIn2Epochs,
  })

  const tryFullRepay = repaymentAsset.isMaxSelected && balance.gt(repayMaxValueIn1Epoch)

  return [
    {
      type: 'repay',
      value: tryFullRepay ? repayMaxValueIn2Epochs : repaymentAsset.value,
      requiredApproval: tryFullRepay ? repayMaxValueIn2Epochs : repaymentAsset.value,
      reserve: repaymentAsset.reserve,
      useAToken: repaymentAsset.token.isAToken,
      initialToken,
      repayFull: tryFullRepay,
    },
  ]
}
